import { Dispatch, SetStateAction, ChangeEvent, createContext } from "react";

export interface QESTextInputContext {
  focused: boolean;
  setFocused: Dispatch<SetStateAction<boolean>>;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  optionsListOpen: boolean;
  highlightedIndex: number;
}

export const TextInputContext = createContext<QESTextInputContext>({
  focused: false,
  highlightedIndex: -1,
  onChange: () => { },
  optionsListOpen: false,
  setFocused: () => { },
});
